import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ref, get } from "firebase/database";
import { database } from "../firebaseConfig";
import ChanceRadarView from "./ChanceRadarView";
import "./ChanceRadar.css";

const GONE = "Diese Recherche ist nicht mehr verfügbar.";

/**
 * Public Chance Radar page: /chance/{publicId}. The server writes the briefing
 * after it has dropped anything without a date and a source. Rules stop serving
 * it once `expiresAt` has passed.
 */
const ChanceRadarPublic = () => {
  const { publicId } = useParams();
  const [state, setState] = useState({ loading: true, briefing: null, error: "" });

  useEffect(() => {
    let alive = true;
    if (!publicId || !/^[A-Za-z0-9_-]{10,64}$/.test(publicId)) {
      setState({ loading: false, briefing: null, error: "Dieser Link ist ungültig." });
      return undefined;
    }
    get(ref(database, `/publicChanceRadars/${publicId}`))
      .then((snap) => {
        if (!alive) return;
        const page = snap.exists() ? snap.val() : null;
        const briefing = page && page.expiresAt > Date.now() ? page.briefing : null;
        setState({ loading: false, briefing, error: briefing ? "" : GONE });
      })
      .catch((err) => {
        if (!alive) return;
        const denied = /permission/i.test(String(err?.code || err?.message || ""));
        setState({
          loading: false,
          briefing: null,
          error: denied ? GONE : "Die Recherche konnte nicht geladen werden.",
        });
      });
    return () => {
      alive = false;
    };
  }, [publicId]);

  const title = state.briefing?.title || "Chance Radar";

  return (
    <div className="cr-page">
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="referrer" content="no-referrer" />
        <link rel="icon" href="data:," />
      </Helmet>
      {state.loading ? (
        <div className="cr-state">Lädt…</div>
      ) : state.error ? (
        <div className="cr-state">{state.error}</div>
      ) : (
        <ChanceRadarView briefing={state.briefing} />
      )}
    </div>
  );
};

export default ChanceRadarPublic;
